import React from 'react';
import { UrgencyBar } from '../components/jealous/UrgencyBar';
import { JealousNav } from '../components/jealous/JealousNav';
import { JealousHero } from '../components/jealous/JealousHero';
import { JealousTrustBar } from '../components/jealous/JealousTrustBar';
import { JealousWhySection } from '../components/jealous/JealousWhySection';
import { JealousHowItWorks } from '../components/jealous/JealousHowItWorks';
import { JealousTestimonials } from '../components/jealous/JealousTestimonials';
import { JealousFAQ } from '../components/jealous/JealousFAQ';
import { JealousFinalCTA } from '../components/jealous/JealousFinalCTA';
import { JealousFooter } from '../components/jealous/JealousFooter';
import { StickyMobileCTA } from '../components/jealous/StickyMobileCTA';
export function JealousNeighborPage() {
  return <div className="w-full min-h-screen relative bg-white" data-id="element-997">
      <style data-id="element-998">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
        `}
      </style>
      <UrgencyBar data-id="element-999" />
      <JealousNav data-id="element-1000" />
      <main className="pt-[44px]" data-id="element-1001">
        <JealousHero data-id="element-1002" />
        <JealousTrustBar data-id="element-1003" />
        <JealousWhySection data-id="element-1004" />
        <JealousHowItWorks data-id="element-1005" />
        <JealousTestimonials data-id="element-1006" />
        <JealousFAQ data-id="element-1007" />
        <JealousFinalCTA data-id="element-1008" />
      </main>
      <JealousFooter data-id="element-1009" />
      <StickyMobileCTA data-id="element-1010" />
    </div>;
}